var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIco = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(45 10.41 5.59)",
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  className: "fill-color",
  y: 8,
  width: 18,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  className: "fill-color",
  transform: "rotate(90 9 9)",
  y: 8,
  width: 18,
  height: 2,
  rx: 1
}))));
export default SvgCloseIco;